/** 오버레이 — 이동 다이얼로그·새 프로젝트 위저드·삭제 확인(2단계)·스낵바(ProjectPickerPage 에서 분리, P4-c) */
import { Alert } from '@mui/material';
import { Snackbar } from '@/shared/ui/overlays';
import { ConfirmDestructiveDialog } from '@/shared/ui/ConfirmDestructiveDialog';
import { MoveProjectDialog, NewProjectWizard, type NewProjectFormData } from '@/features/project-picker';
import type { ProjectSummary, Workspace } from '@/types/project';
import type { Notice } from './useProjectMutations';

export interface PickerOverlaysProps {
  moveTarget: ProjectSummary | null; workspaces: Workspace[]; onCloseMove: () => void; onMove: (projectId: string, workspaceId: string) => void;
  newProjectDialogOpen: boolean; onCloseNewProject: () => void; onCreated: (id: string) => void; onCreate: (d: NewProjectFormData) => Promise<string | null>; loading: boolean; error: string | null; existingTitles: string[];
  deleteDialogOpen: boolean; onCloseDelete: () => void; onConfirmDelete: () => void;
  forceConfirm: { id: string; remainingFiles: number } | null; onCancelForce: () => void; onConfirmForce: () => void;
  notice: Notice & { open: boolean }; onCloseNotice: () => void;
}

export function PickerOverlays(p: PickerOverlaysProps) {
  return (
    <>
      <MoveProjectDialog project={p.moveTarget} workspaces={p.workspaces} onClose={p.onCloseMove} onMove={p.onMove} />
      <NewProjectWizard open={p.newProjectDialogOpen} onClose={p.onCloseNewProject} onCreated={p.onCreated} loading={p.loading} error={p.error} onCreate={p.onCreate} existingTitles={p.existingTitles} />
      <ConfirmDestructiveDialog open={p.deleteDialogOpen} title="프로젝트 삭제" message="이 프로젝트를 삭제하시겠습니까? 이 작업은 되돌릴 수 없습니다." confirmLabel="삭제" pending={p.loading} onCancel={p.onCloseDelete} onConfirm={p.onConfirmDelete} />
      {/* 2단계 확인 — 모델 폴더에 파일이 남아 서버가 거절했을 때만 뜬다. 서버는 실행 폴더 밖(모델 파일)만 세고 지운다 —
          실행 기록과 결과는 실행 기록을 지울 때 지워진다(docs/DESIGN-run-input-lifecycle.md §6.11) */}
      <ConfirmDestructiveDialog
        open={p.forceConfirm !== null}
        title="모델 파일도 함께 삭제"
        message={`이 프로젝트에는 모델 파일(빌드한 FMU 등) ${p.forceConfirm?.remainingFiles ?? 0}개가 남아 있습니다. 프로젝트와 함께 모두 삭제됩니다. 실행 기록과 그 결과는 남습니다 — 실행 기록에서 지울 수 있습니다. 이 작업은 되돌릴 수 없습니다.`}
        confirmLabel="모두 삭제"
        pending={p.loading}
        onCancel={p.onCancelForce}
        onConfirm={p.onConfirmForce}
      />
      <Snackbar open={p.notice.open} autoHideDuration={4000} onClose={p.onCloseNotice} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
        <Alert onClose={p.onCloseNotice} severity={p.notice.severity} variant="filled">{p.notice.message}</Alert>
      </Snackbar>
    </>
  );
}
